import React, { useState, useEffect, useContext } from 'react';
import './style.css';

import RiskOverviewStandardSectionHeader from '/src/Components/RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
import ProjectsSummaryData from '/src/Components/ProjectsSummaryData/ProjectsSummaryData';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { CreateGoogleMapsStreetviewUrl } from '/src/services/CreateGoogleMapsStreetviewUrl';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import { WindowSizeContext } from '/src/App';

const AboutProjects = ({ propertyData, handleExploreProjectsClick }) => {
    const { deviceType } = useContext(WindowSizeContext);
    // Get the latitude and longitude of the property
    const latitude = propertyData?.data?.property_details?.lat;
    const longitude = propertyData?.data?.property_details?.long;

    // Create the streetview url if the latitude and longitude are available
    const streetviewUrl = latitude && longitude ? CreateGoogleMapsStreetviewUrl(latitude, longitude) : null;

    const intro_sentence = "The best way to protect this home, and your wallet, is through targeted home resilience improvements. Based on this property’s risk profile, we’ve modeled a wide variety of different options to give you a tailored list of recommendations that are both easy to achieve and provide a clear financial return. Click below to see the projects.";
    // const intro_sentence = "Improving this home’s resilience is one of the best ways to safeguard both the property and your wallet. We’ve modeled a range of upgrades based on your home’s risk profile — selecting projects that deliver real protection and financial value. Whether you take on one or many, every step makes a difference.";

    const projects_list = propertyData?.data?.recommended_projects?.projects_list || [];
    // const section_title = "The Goal is to Increase This Home’s Resilience";
    const section_title = "Increasing Resilience is How You Protect This Home";

    return (
        <div className="your-options-section-container">
            <RiskOverviewStandardSectionHeader title={section_title} />
            <div className={`about-projects-grid ${deviceType}`}>
                <div className="about-projects-left-column">
                    {streetviewUrl && (
                        <div className={`your-options-section-streetview-container ${deviceType}`} >
                            <img
                                src={streetviewUrl}
                                alt="Street View"
                                className="your-options-section-streetview-image"
                            />
                        </div>
                    )}
                    <p 
                        className="your-options-section-intro-sentence text-align-center" 
                        dangerouslySetInnerHTML={{ __html: intro_sentence }} 
                    />
                </div>
                
                <div className="about-projects-divider">
                    <CurlyBraceDivider direction={deviceType === "desktop" ? "right" : "down"} />
                </div>

                <div className="about-projects-right-column">
                    {propertyData && <ProjectsSummaryData projects_list={projects_list} propertyData={propertyData} />}
                </div>
            </div>
            <CTAButton text="See the Recommended Projects" onClick={handleExploreProjectsClick} />
        </div>
    );
};

export default AboutProjects;